// extracted by css-extract-rspack-plugin
export default {"heading":"heading-Ngu6Mq","title":"title-x2GKM0","question":"question-ILWsSt"};